import { CartAddEvent } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';
import { fetchConfig } from '@theme/utilities';
// FInal Working

class MatchingPair extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll(
      ".tab-button[data-step][data-target]"
    );
    this.styleOptions = this.querySelectorAll(
      ".style-option[data-step][data-style]"
    );
    this.sizeOptions = this.querySelectorAll(".size-option-women[data-step]");
    this.atcBtn = this.querySelector('#add-to-cart-btn');
    this._stickyBtn = this.querySelector('.mp-sticky-btn');
    this.data = {
      stepOne: {
        style: { image: null, name: null, tabBtn: null },
        size: null,
        color: null,
      },
      stepTwo: {
        style: { image: null, name: null, tabBtn: null },
        size: null,
        color: null,
      },
    };
    this.currentStep = 1;
    this.editingStep = null; // 1 or 2 while editing, null otherwise
    this._editDelegated = false;
    this.mediaForceVisible = false;  // when editing, always show selected images
    this.hasSelectedColor = false;  // becomes true after picking color in step 3

    // save the default HTML so we can restore the initial image anytime
    const mediaBox0 = this.querySelector('.product-media.step-one-two') || document.querySelector('.product-media.step-one-two');
    this._defaultMediaHTML = mediaBox0 ? mediaBox0.innerHTML : '';

  }

  connectedCallback() {
    this.initTabs();
    this.initStyleSelectors();
    this.initSizeSelectors();
    this.initColorSelectors();
    this.initEditHandlers();
    this.navigateSteps();
    this.initStepTitles(); // 👈 NEW
    this.updateMediaBox(); // paint default on load (or selected if editing/color chosen)

    if (this.atcBtn) {
      this.atcBtn.addEventListener('click', () => this.addToCart());
    }
    this.initStickyBar();
    this.updateStickyBar();
  }

  // Helpers
  getMediaBox() {
    if (this._mediaBox && document.contains(this._mediaBox)) return this._mediaBox;
    this._mediaBox = this.querySelector('.product-media.step-one-two')
      || document.querySelector('.product-media.step-one-two')
      || null;
    return this._mediaBox;
  }

  syncUI() {
    this.updateMediaBox();
    this.updateStickyBar();
  }

  setFinalSelectedColorPreviewVisibility(isVisible) {
    this.querySelectorAll('#final-selected-color-preview').forEach((preview) => {
      preview.hidden = !isVisible;
      if (!isVisible) preview.innerHTML = '';
    });
  }

  resetAll() {
    // --- 1) Reset data/state ---
    this.data = {
      stepOne: { style: { image: null, name: null, tabBtn: null }, size: null, color: null },
      stepTwo: { style: { image: null, name: null, tabBtn: null }, size: null, color: null },
    };
    this.data.stepThree = [];
    this.currentStep = 1;
    this.editingStep = null;
    this.mediaForceVisible = false;
    this.hasSelectedColor = false;

    // --- 2) Clear UI selections ---
    this.querySelectorAll('.style-option.active, .size-option-women.active').forEach(el => el.classList.remove('active'));
    const colorPreview = this.querySelector('#matching-colors-preview'); if (colorPreview) colorPreview.innerHTML = '';
    const finalPreview = this.querySelector('#final-selected-color-preview'); if (finalPreview) finalPreview.innerHTML = '';
    this.setFinalSelectedColorPreviewVisibility(false);

    // clear selected texts/labels
    this.querySelectorAll(
      '.selected-styles-1, .selected-styles-2, .selected-size-1, .selected-size-2,' +
      '[data-selected-style="1"], [data-selected-style="2"], [data-selected-size="1"], [data-selected-size="2"]'
    ).forEach(el => el.textContent = '');

    const finalColor = this.querySelector('.final-color'); if (finalColor) finalColor.textContent = '';
    const selTitle = this.querySelector('.mp-selected-title'); if (selTitle) selTitle.textContent = 'Bummer x Santanu';

    // --- 3) Restore step visibility (only Step 1 open, men tab by default) ---
    this.querySelectorAll('.step .step-content').forEach(c => c.classList.add('hidden'));
    this.querySelector('.step[data-step="1"] .step-content')?.classList.remove('hidden');

    this.querySelectorAll('.mp-content').forEach(c => c.classList.add('hidden'));
    this.querySelector('.mp-content[data-step="1"][data-target="men-content-1"]')?.classList.remove('hidden');

    // tabs: first tab active in every group
    this.querySelectorAll('.tabs').forEach(group => {
      const buttons = [...group.querySelectorAll('.tab-button')];
      buttons.forEach((b, i) => b.classList.toggle('active', i === 0));
    });

    // --- 4) Buttons disabled again ---
    ['1', '2'].forEach(s => {
      this.querySelectorAll(`.step[data-step="${s}"] .continue-btn[data-step="${s}"]`)
        .forEach(b => { b.disabled = true; b.setAttribute('disabled', ''); });
    });
    const step3Btn = this.querySelector('.continue-btn[data-step="3"]');
    if (step3Btn) step3Btn.setAttribute('disabled', '');

    // --- 5) Reset the media area to default (if available) ---
    if (typeof this.showDefaultMedia === 'function') {
      this.showDefaultMedia();
    } else {
      // fallback: hide step-3 media, show step-one-two as-is
      const box3 = this.querySelector('.product-media.step-three'); if (box3) box3.classList.add('hidden');
      const box12 = this.querySelector('.product-media.step-one-two'); if (box12) box12.classList.remove('hidden');
    }

    // --- 6) Sticky bar / labels refresh (if present) ---
    if (typeof this.updateStickyBar === 'function') this.updateStickyBar();

    // --- 7) Scroll container to top (modal or page) ---
    const container = this.closest('#matching-pair-modal')?.querySelector('.modal-inner')
      || document.scrollingElement || document.documentElement;
    if (container === document.scrollingElement || container === document.documentElement) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    } else {
      container.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

  formatMoneyFromCents(cents) {
    const currency = (window.Shopify?.currency?.active) || 'INR';
    const value = (Number(cents) || 0) / 100;
    return value.toLocaleString(undefined, { style: 'currency', currency });
  }

  normalizeImageUrl(rawValue) {
    if (!rawValue) return null;
    const trimmed = String(rawValue).trim();
    if (!trimmed) return null;

    // unwrap url(...) if present
    const unwrapped = trimmed.replace(/^url\((.*?)\)$/i, '$1');

    if (/^https?:\/\//i.test(unwrapped)) return unwrapped;
    if (unwrapped.startsWith('//')) return `https:${unwrapped}`;

    return unwrapped;
  }

  getCombinedPriceCents() {
    const st3 = this.data?.stepThree?.[0];
    const p1 = parseInt(st3?.stepOneProduct?.price ?? 0, 10);
    const p2 = parseInt(st3?.stepTwoProduct?.price ?? 0, 10);
    return (isNaN(p1) ? 0 : p1) + (isNaN(p2) ? 0 : p2);
  }

  // helper: show only the selected style's size chart (Men step scope)
  showMenSizeChartFor(step, styleName) {
    const stepScope =
      this.querySelector(`.mp-content[data-step="${step}"]`) ||
      this.querySelector(`.step[data-step="${step}"] .step-content`);
    if (!stepScope) return;

    const root = stepScope.querySelector(".scw-size-chart-men");
    if (!root) return;

    const holders = root.querySelectorAll(".bundle-size-chart-holder");
    holders.forEach(h => h.hidden = true);

    const target = root.querySelector(
      `.bundle-size-chart-holder[data-style-name="${(styleName || '').toLowerCase()}"]`
    );

    // Toggle the shared "Size Guide" button
    const openBtn = root.querySelector("[data-bundle-sizechart-btn]");
    if (target) {
      // reveal only the matching chart and show the button
      target.hidden = false;
      this.bindUnitToggle(target)
      if (openBtn) openBtn.hidden = false;

      // Wire the open/close only once
      if (!openBtn._mpBound) {
        openBtn._mpBound = true;
        openBtn.addEventListener("click", () => {
          // open the currently visible chart’s modal
          const visible = root.querySelector('.bundle-size-chart-holder:not([hidden])');
          const modal = visible?.querySelector(".size-chart-modal");
          const overlay = visible?.querySelector(".size-chart-overlay");
          const wrapper = visible?.querySelector(".size-chart-wrapper");
          if (modal && overlay) {
            modal.classList.add("active");
            overlay.classList.add("active");
            wrapper?.classList.add("open");
          }
        });

        // Delegate close on overlay / close icon from any visible chart
        root.addEventListener("click", (e) => {
          const closeHit = e.target.closest("[bundle-size-chart-close-btn]") ||
            e.target.closest(".size-chart-overlay");
          if (!closeHit) return;
          const visible = root.querySelector('.bundle-size-chart-holder:not([hidden])');
          if (!visible) return;
          visible.querySelector(".size-chart-modal")?.classList.remove("active");
          visible.querySelector(".size-chart-overlay")?.classList.remove("active");
          visible.querySelector(".size-chart-wrapper")?.classList.remove("open");
        });
      }
    } else {
      // no tagged product / chart for this style → hide button
      if (openBtn) openBtn.hidden = true;
    }
  }

  // Show only the selected style's size chart (Women scope)
  showWomenSizeChartFor(step, styleName) {

    const stepScope =
      this.querySelector(`.mp-content[data-target="women-content-${step}"]`);
    if (!stepScope) return;

    const root = stepScope.querySelector(".scw-size-chart-women");
    if (!root) return;

    // Hide all first
    root.querySelectorAll(".bundle-size-chart-holder").forEach(h => h.hidden = true);

    // Reveal the matching style's chart (if any)
    const target = root.querySelector(
      `.bundle-size-chart-holder[data-style-name="${(styleName || '').toLowerCase()}"]`
    );

    const openBtn = root.querySelector("[data-bundle-sizechart-btn]");
    if (target) {
      target.hidden = false;
      this.bindUnitToggle(target)
      if (openBtn) openBtn.hidden = false;

      // Bind once
      if (!openBtn._mpBound) {
        openBtn._mpBound = true;
        openBtn.addEventListener("click", () => {
          const visible = root.querySelector('.bundle-size-chart-holder:not([hidden])');
          const modal = visible?.querySelector(".size-chart-modal");
          const overlay = visible?.querySelector(".size-chart-overlay");
          const wrapper = visible?.querySelector(".size-chart-wrapper");
          if (modal && overlay) {
            modal.classList.add("active");
            overlay.classList.add("active");
            wrapper?.classList.add("open");
          }
        });

        root.addEventListener("click", (e) => {
          const closeHit = e.target.closest("[bundle-size-chart-close-btn]") ||
            e.target.closest(".size-chart-overlay");
          if (!closeHit) return;
          const visible = root.querySelector('.bundle-size-chart-holder:not([hidden])');
          if (!visible) return;
          visible.querySelector(".size-chart-modal")?.classList.remove("active");
          visible.querySelector(".size-chart-overlay")?.classList.remove("active");
          visible.querySelector(".size-chart-wrapper")?.classList.remove("open");
        });
      }
    } else {
      if (openBtn) openBtn.hidden = true;
    }
  }

  bindUnitToggle(scope) {
    if (!scope || scope._unitToggleBound) return;
    scope._unitToggleBound = true;

    const wrapper = scope.querySelector('.size-chart-wrapper');
    if (!wrapper) return;

    const IN_TO_CM = 2.54;

    const fmt = (num, digits = 0) => {
      const n = Number(num);
      if (!isFinite(n)) return String(num);
      return n.toFixed(digits).replace(/\.0+$/, '');
    };

    // "26", "26-28", "26 – 28"
    const convertRangeText = (text, to) => {
      if (!text) return text;
      let s = String(text).trim().replace(/[–—]/g, '-');
      const parts = s.split(/\s*-\s*/);

      const conv = (v) => {
        const n = parseFloat(String(v).trim());
        if (!isFinite(n)) return v;
        if (to === 'cm') return fmt(n * IN_TO_CM, 0); // whole cm
        if (to === 'in') return fmt(n / IN_TO_CM, 1); // 1 decimal in
        return v;
      };

      return parts.length === 1 ? conv(parts[0]) : parts.map(conv).join('–');
    };

    // Ensure we have a stable source-of-truth attribute
    const primeSourceAttrs = () => {
      wrapper.querySelectorAll('.size-chart-values').forEach(cell => {
        if (!cell.hasAttribute('data-inch') && !cell.hasAttribute('data-cm')) {
          // Assume current text is inches by default; change to 'data-cm' if your data is cm-first
          cell.setAttribute('data-inch', (cell.textContent || '').trim());
        }
      });
    };

    const setUnit = (unit) => {
      wrapper.dataset.unit = unit;

      // Tab UI
      wrapper.querySelectorAll('.size-chart_tabs-text').forEach(t => {
        t.classList.toggle('active', (t.dataset.unit || '') === unit);
      });

      // Convert or show as-is depending on what the cell stores
      wrapper.querySelectorAll('.size-chart-values').forEach(cell => {
        const hasIn = cell.hasAttribute('data-inch');
        const hasCm = cell.hasAttribute('data-cm');
        const srcIn = hasIn ? cell.getAttribute('data-inch') : null;
        const srcCm = hasCm ? cell.getAttribute('data-cm') : null;

        if (unit === 'in') {
          if (hasIn) {
            // already inches → show as-is (NO conversion)
            cell.textContent = srcIn;
          } else if (hasCm) {
            // stored cm → convert to inches
            cell.textContent = convertRangeText(srcCm, 'in');
          } else {
            // fallback: leave current text
          }
        } else if (unit === 'cm') {
          if (hasCm) {
            // already cm → show as-is
            cell.textContent = srcCm;
          } else if (hasIn) {
            // stored inches → convert to cm
            cell.textContent = convertRangeText(srcIn, 'cm');
          } else {
            // fallback: convert current text assuming inches
            cell.textContent = convertRangeText((cell.textContent || '').trim(), 'cm');
          }
        }
      });
    };

    // Wire tabs
    wrapper.addEventListener('click', (e) => {
      const tab = e.target.closest('.size-chart_tabs-text');
      if (!tab) return;
      setUnit(tab.dataset.unit);
    });

    // Initialize once the chart is first shown
    primeSourceAttrs();
    const active = wrapper.querySelector('.size-chart_tabs-text.active');
    setUnit(active?.dataset.unit || 'in'); // your default is IN
  }

  refreshATCPrices() {
    const total = this.getCombinedPriceCents();
    const formatted = this.formatMoneyFromCents(total);

    if (this.atcBtn) this.atcBtn.textContent = `ADD TO BAG • ${formatted}`;

    // Also update sticky bar when on Step 4
    const sticky = this._stickyBtn
    if (sticky && this.currentStep === 4) {
      sticky.textContent = `ADD TO BAG • ${formatted}`;
    }
  }

  initStickyBar() {
    if (!this._stickyBtn) return;

    // Proxy click to the proper native button
    this._stickyBtn.addEventListener('click', () => {
      if (this._stickyBtn.disabled) return;

      if (this.editingStep) {
        // click UPDATE button inside the step being edited
        this.querySelector(`.step[data-step="${this.editingStep}"] .continue-btn`)?.click();
        return;
      }

      if (this.currentStep === 1) {
        this.querySelector('.continue-btn[data-step="1"]')?.click();
      } else if (this.currentStep === 2) {
        this.querySelector('.continue-btn[data-step="2"]')?.click();
      } else if (this.currentStep === 3) {
        this.querySelector('.continue-btn[data-step="3"]')?.click()
          || this.querySelector('.continue-btn[data-step-final]')?.click();
      } else if (this.currentStep === 4) {
        // visual: mark sticky as ATC + loading
        this._stickyBtn.classList.add('secondary-atc', 'loading');
        this._stickyBtn.disabled = true;

        // (optional) mirror loading on the main ATC too
        const atc = this.querySelector('#add-to-cart-btn');
        if (atc) atc.classList.add('loading');

        this.querySelector('#add-to-cart-btn')?.click();
      }
    });
  }

  // Show only sizes that exist for the selected style (per step 1/2 and current tab)
  filterSizes(step) {
    const stepStr = String(step); // "1" | "2"
    const stepData = stepStr === "1" ? this.data.stepOne : this.data.stepTwo;
    const styleName = stepData?.style?.name;

    const activeTarget =
      stepData?.style?.tabBtn ||
      this.querySelector(`.tab-button[data-step="${stepStr}"].active`)
        ?.getAttribute("data-target") ||
      "";

    // Use the correct source list (men/women) based on the active tab
    const source = activeTarget.includes("women")
      ? Array.from(this.querySelectorAll(".all-color-women"))
      : Array.from(this.querySelectorAll(".all-color-men"));

    // Collect all valid sizes for the selected style
    const validSizes = new Set();
    if (styleName) {
      source.forEach((btn) => {
        if (btn.getAttribute("data-style") === styleName) {
          const sz = btn.getAttribute("data-size");
          if (sz) validSizes.add(sz);
        }
      });
    }

    // Show/hide size buttons accordingly
    const sizeBtns = this.querySelectorAll(`.size-option-women[data-step="${stepStr}"]`);
    sizeBtns.forEach((b) => {
      const sz = b.getAttribute("data-size");
      const shouldShow = styleName && validSizes.has(sz);
      b.classList.toggle("hidden", !shouldShow);
      if (!shouldShow && b.classList.contains("active")) {
        b.classList.remove("active");
      }
    });

    // If previously selected size is no longer valid, clear it
    if (stepData.size && !validSizes.has(stepData.size)) {
      stepData.size = null;
      this.querySelectorAll(`.selected-size-${stepStr}, [data-selected-size="${stepStr}"]`)
        .forEach(el => el.textContent = '');
      this.enableContinueButton(stepStr);
    }
  }

  updateStickyBar() {
    const btn = this._stickyBtn
    if (!btn) return;

    // Editing → show UPDATE and mirror that step's continue button disabled state
    if (this.editingStep) {
      btn.textContent = 'UPDATE';
      const editBtn = this.querySelector(`.step[data-step="${this.editingStep}"] .continue-btn`);
      btn.disabled = !!(editBtn && editBtn.disabled);
      return;
    }
    if (this.currentStep === 1) {
      btn.textContent = 'Select your partner pair';
      const native = this.querySelector('.continue-btn[data-step="1"]');
      btn.disabled = !!(native && native.disabled);
    } else if (this.currentStep === 2) {
      btn.textContent = 'Select your colors';
      const native = this.querySelector('.continue-btn[data-step="2"]');
      btn.disabled = !!(native && native.disabled);
    } else if (this.currentStep === 3) {
      btn.textContent = 'Review your pairs';
      const finalBtn = this.querySelector('.continue-btn[data-step="3"], .continue-btn[data-step-final]');
      btn.disabled = !!(finalBtn && finalBtn.disabled);
    } else if (this.currentStep === 4) {
      const total = this.getCombinedPriceCents();
      btn.textContent = `ADD TO BAG • ${this.formatMoneyFromCents(total)}`;
      btn.disabled = false;
    }
  }

  // Return style image for step "one" | "two"
  getStyleImg(which) {
    return which === 'one'
      ? (this?.data?.stepOne?.style?.featuredProductImage || '')
      : (this?.data?.stepTwo?.style?.featuredProductImage || '');
  }

  // Return chosen variant image for step "one" | "two" (color-picked), fallback ''
  getVariantImg(which) {
    const st3 = this.data?.stepThree?.[0];
    if (which === 'one') {
      return st3?.stepOneProduct?.variantFeaturedImage ||
        st3?.stepOneProduct?.variantFeaturedImageSecondary ||
        st3?.stepOneProduct?.variantImage || '';
    } else {
      return st3?.stepTwoProduct?.variantFeaturedImage ||
        st3?.stepTwoProduct?.variantFeaturedImageSecondary ||
        st3?.stepTwoProduct?.variantImage || '';
    }
  }

  swapImg(imgEl, nextSrc) {
    if (!imgEl) return;
    const newSrc = nextSrc || '';

    // nothing to change
    if (imgEl.dataset.src === newSrc) return;

    // store last src separately to compare
    imgEl.dataset.src = newSrc;

    if (!newSrc) {
      imgEl.removeAttribute('src');
      return;
    }

    // preload then swap
    const tmp = new Image();
    tmp.onload = () => {
      // only update if still the expected src
      if (imgEl.dataset.src === newSrc) {
        imgEl.src = newSrc;
      }
    };
    tmp.src = newSrc;
  }

  ensureImg(target, alt) {
    if (!target) return null;
    let img = target.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = alt || '';
      img.style.width = '100%';
      img.style.height = 'auto';
      img.style.borderRadius = '0px';
      img.style.objectFit = 'cover';
      target.appendChild(img);
    }
    return img;
  }

  // Render helper: 'single-one' | 'single-two' | 'both'
  // Uses variant first when available, otherwise style.
  renderMedia(mode) {
    const box = this.getMediaBox();
    if (!box) return;

    const one = this.getVariantImg('one') || this.getStyleImg('one');
    const two = this.getVariantImg('two') || this.getStyleImg('two');

    // 1) Ensure a stable structure (no re-create)
    box.classList.remove('hidden');
    let grid = box.querySelector('[data-media-grid]');
    if (!grid) {
      grid = document.createElement('div');
      grid.classList.add("final-images-review")
      grid.setAttribute('data-media-grid', '1');
      grid.style.display = 'grid';
      grid.style.gridTemplateColumns = 'repeat(2,minmax(0,1fr))';
      grid.style.gap = '0px';
      box.innerHTML = '';
      box.appendChild(grid);
    }

    // Choose 1 or 2 cells depending on mode
    grid.style.gridTemplateColumns = (mode === 'single-one' || mode === 'single-two')
      ? '1fr' : 'repeat(2,minmax(0,1fr))';

    // Cell A
    let cellA = grid.firstElementChild;
    if (!cellA) { cellA = document.createElement('div'); grid.appendChild(cellA); }
    const imgA = this.ensureImg(cellA, mode === 'single-two' ? 'Your partner' : 'You');

    // Cell B (only if both)
    let imgB = null;
    if (mode === 'both') {
      let cellB = grid.children[1];
      if (!cellB) { cellB = document.createElement('div'); cellB.classList.add("first-image-preview"); grid.appendChild(cellB); }
      imgB = this.ensureImg(cellB, 'Your partner');
    } else {
      // remove second cell if present
      while (grid.children.length > 1) grid.removeChild(grid.lastElementChild);
    }

    // 2) Swap sources with preload (no flicker)
    const demo = "https://cdn.shopify.com/s/files/1/0231/1448/1744/files/Frame_1.png?v=1699247014";
    if (mode === 'single-one') {
      this.swapImg(imgA, one || demo);
    } else if (mode === 'single-two') {
      this.swapImg(imgA, two || demo);
    } else {
      this.swapImg(imgA, one || demo);
      this.swapImg(imgB, two || demo);
    }

    // 3) Mirror to Step-3 preview without rebuilding DOM
    const preview = this.querySelector('#final-selected-color-preview');
    if (preview && this.hasSelectedColor) {
      this.setFinalSelectedColorPreviewVisibility(true);
      let gridP = preview.querySelector('[data-media-grid]');
      if (!gridP) {
        gridP = document.createElement('div');

        gridP.setAttribute('data-media-grid', '1');
        gridP.style.display = 'grid';
        gridP.style.gridTemplateColumns = 'repeat(2,minmax(0,1fr))';
        gridP.style.gap = '12px';
        preview.innerHTML = '';
        preview.appendChild(gridP);
      }
      let pA = gridP.firstElementChild; if (!pA) { pA = document.createElement('div'); gridP.appendChild(pA); }
      let pB = gridP.children[1]; if (!pB) { pB = document.createElement('div'); gridP.appendChild(pB); }
      const pImgA = this.ensureImg(pA, 'You');
      const pImgB = this.ensureImg(pB, 'Your partner');

      this.swapImg(pImgA, one || demo);
      this.swapImg(pImgB, two || demo);
    } else {
      this.setFinalSelectedColorPreviewVisibility(false);
    }
  }

  showDefaultMedia() {
    const box = this.getMediaBox();
    if (!box) return;
    box.classList.remove('hidden');            // keep visible on steps 1 & 2
    if (this._defaultMediaHTML) box.innerHTML = this._defaultMediaHTML;
  }

  renderSelectedMedia() {
    const box = this.getMediaBox();
    if (!box) return;

    const st3 = this.data?.stepThree?.[0];
    const img1 =
      st3?.stepOneProduct?.variantFeaturedImage ||
      st3?.stepOneProduct?.variantImage ||
      this?.data?.stepOne?.style?.image || '';
    const img2 =
      st3?.stepTwoProduct?.variantFeaturedImage ||
      st3?.stepTwoProduct?.variantImage ||
      this?.data?.stepTwo?.style?.image || '';

    box.classList.remove('hidden');
    box.innerHTML = `
      <div class="final-image-review">
        <img loading="lazy" alt="You" src="${img1}" style="width:100%;height:auto;border-radius:12px;object-fit:cover;">
        <img loading="lazy" alt="Your partner" src="${img2}" style="width:100%;height:auto;border-radius:12px;object-fit:cover;">
      </div>
    `;
  }

  updateMediaBox() {
    const box = this.getMediaBox();
    if (!box) return;

    // If editing: always show "both" (variant if picked; style fallback)
    if (this.mediaForceVisible) {
      this.renderMedia('both');
      return;
    }

    // If a color has been chosen at least once (Step 3 reached)
    if (this.hasSelectedColor || this.currentStep >= 3) {
      this.renderMedia('both');
      return;
    }

    // BEFORE color step: single image logic
    const s1Ready = !!(this?.data?.stepOne?.style?.name && this?.data?.stepOne?.size);
    const s2Ready = !!(this?.data?.stepTwo?.style?.name && this?.data?.stepTwo?.size);

    if (this.currentStep === 1 && s1Ready) {
      // Show only Step-1 image (style image, since color not chosen yet)
      this.renderMedia('single-one');
      return;
    }
    if (this.currentStep === 2 && s2Ready) {
      // Replace with only Step-2 image
      this.renderMedia('single-two');
      return;
    }

    // Otherwise (no selection yet): keep your default image visible
    this.showDefaultMedia();
  }

  // --- Tab switching logic ---
  initTabs() {
    this.tabButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const step = btn.getAttribute("data-step");
        const target = btn.getAttribute("data-target");

        // Find only the current tab group
        const tabGroup = btn.closest(".tabs");
        if (!tabGroup) return;

        // Reset active only inside this group
        const siblingButtons = tabGroup.querySelectorAll(".tab-button");
        siblingButtons.forEach((b) => b.classList.remove("active"));

        // Activate clicked button
        btn.classList.add("active");

        // Hide all contents for this step
        const stepContents = this.querySelectorAll(
          `.mp-content[data-step="${step}"]`
        );
        stepContents.forEach((c) => c.classList.add("hidden"));

        // Show the matching content
        const activeContent = this.querySelector(
          `.mp-content[data-step="${step}"][data-target="${target}"]`
        );
        if (activeContent) {
          activeContent.classList.remove("hidden");

          // 🔑 NEW: Auto-activate the matching tab button in the new content's tab group
          const innerTabGroup = activeContent.querySelector(".tabs");
          if (innerTabGroup) {
            const matchingBtn = innerTabGroup.querySelector(
              `.tab-button[data-target="${target}"]`
            );
            if (matchingBtn) {
              // clear previous
              innerTabGroup
                .querySelectorAll(".tab-button")
                .forEach((b) => b.classList.remove("active"));
              matchingBtn.classList.add("active");
            }
          }
        }
        this.currentStep = parseInt(step);
        this.updateStickyBar();
      });
    });

    // Auto-init: run once per group
    const tabGroups = this.querySelectorAll(".tabs");
    tabGroups.forEach((group) => {
      const firstTab = group.querySelector(".tab-button");
      if (firstTab && !group.querySelector(".tab-button.active")) {
        firstTab.click();
      }
    });
  }

  // --- Style selection logic ---
  initStyleSelectors() {
    this.styleOptions.forEach((btn) => {
      btn.addEventListener("click", () => {
        const step = btn.getAttribute("data-step");
        const style = btn.getAttribute("data-style");
        const image =
          btn.getAttribute("data-style-image") ||
          btn.querySelector("img")?.src ||
          null;

        const featuredProductImage = btn.getAttribute("data-product-image") || btn.querySelector("img")?.src || null;

        // Find active tab for this step
        const activeTab = this.querySelector(
          `.tab-button[data-step="${step}"].active`
        );
        const tabTarget = activeTab
          ? activeTab.getAttribute("data-target")
          : null;

        // Set as active and update data based on current step
        const stepBtns = this.querySelectorAll(
          `.style-option[data-step="${step}"]`
        );
        stepBtns.forEach((b) => b.classList.toggle("active", b === btn));
        const mainParent = btn.closest(".mp-content");

        this.querySelectorAll(`.selected-styles-${step}`).forEach(el => {
          el.textContent = '';
        })

        const selectedStyle = mainParent?.querySelector(`[data-selected-style="${step}"]`);
        if (selectedStyle) {
          selectedStyle.textContent = style ? `: ${style}` : '';
        }

        const stepData = step === "1" ? this.data.stepOne : this.data.stepTwo;
        stepData.style = { image, name: style, tabBtn: tabTarget, featuredProductImage: featuredProductImage };

        this.querySelectorAll(`.size-option-women[data-step="${step}"]`)
          .forEach((el) => el.classList.remove("active"));

        this.querySelectorAll(`.selected-size-${step}, [data-selected-size="${step}"]`)
          .forEach(el => { el.textContent = ''; });

        // 2) Clear the saved size for this step
        stepData.size = null;

        this.showMenSizeChartFor(step, style);
        this.showWomenSizeChartFor(step, style);
        this.enableContinueButton(step, mainParent);
        this.filterColors();
        // this.initColorSelectors(); // filterColors already (re)binds color handlers
        // if (!this.editingStep) this.navigateSteps(); // bind once with guards
        this.hasSelectedColor = false;
        this.data.stepThree = []; // clears any previous variant images
        this.syncUI();
        this.filterSizes(step);
      });
    });
  }

  // --- Size selection logic ---
  initSizeSelectors() {
    this.sizeOptions.forEach((btn) => {
      btn.addEventListener("click", () => {
        const step = btn.getAttribute("data-step");   // "1" | "2"
        const size = btn.getAttribute("data-size");

        // Detect current tab for this step
        const activeTab = this.querySelector(`.tab-button[data-step="${step}"].active`);
        const tabTarget = activeTab ? activeTab.getAttribute("data-target") : null;

        const stepData = step === "1" ? this.data.stepOne : this.data.stepTwo;

        // 🔁 If user is choosing SIZE in a *different tab* than where STYLE was chosen,
        // reset the prior style (and its UI) for THIS step so there’s no stale carryover.
        const prevStyleTab = stepData?.style?.tabBtn || null;
        if (prevStyleTab && tabTarget && prevStyleTab !== tabTarget) {
          // 1) Clear style texts (everywhere for this step)
          this.querySelectorAll(`.selected-styles-${step}, [data-selected-style="${step}"]`)
            .forEach(el => { el.textContent = ''; });

          // 2) Remove active state from style buttons for this step
          this.querySelectorAll(`.style-option[data-step="${step}"]`)
            .forEach(el => el.classList.remove('active'));

          // 3) Nuke stored style (force user to re-pick style under this tab)
          stepData.style = { image: null, name: null, tabBtn: tabTarget, featuredProductImage: null };

          // 4) Since style changed, size is invalid → clear any size text before we set the new one
          this.querySelectorAll(`.selected-size-${step}, [data-selected-size="${step}"]`)
            .forEach(el => { el.textContent = ''; });

          // 5) Reset color-related state
          this.hasSelectedColor = false;
          this.data.stepThree = [];

          // 6) Refresh dependent UI
          this.enableContinueButton(step, btn.closest(".mp-content"));
          this.filterColors();
          this.updateMediaBox();
          this.updateStickyBar();
        }

        // (existing code) mark this size active for this tab
        const stepBtns = this.querySelectorAll(`.size-option-women[data-step="${step}"]`);
        stepBtns.forEach((b) => b.classList.toggle("active", b === btn));

        // (existing) persist the size and update the visible label in this panel
        stepData.size = size;
        const mainParent = btn.closest(".mp-content");

        this.querySelectorAll(`.selected-size-${step}`).forEach(el => { el.textContent = ''; });
        const selectedSize = mainParent?.querySelector(`[data-selected-size="${step}"]`);
        if (selectedSize) selectedSize.textContent = size ? `: ${size}` : '';

        // (existing) cascade updates
        this.enableContinueButton(step, mainParent);
        this.filterColors();
        // this.initColorSelectors(); // filterColors handles binding
        // if (!this.editingStep) this.navigateSteps(); // bind once with guards
        this.hasSelectedColor = false;
        this.data.stepThree = [];
        this.syncUI();
      });
    });
  }

  // --- Color selection logic ---
  initColorSelectors() {
    const previewContainer = this.querySelector("#matching-colors-preview");
    if (!previewContainer) return;

    // Use only direct children of preview container (the cloned color buttons)
    const availableColors = Array.from(previewContainer.children || []);
    const step3Btn = this.querySelector('.continue-btn[data-step="3"]');
    if (availableColors.length === 0) {
      this.setFinalSelectedColorPreviewVisibility(false);
      // this.querySelector('.continue-btn[data-step="3"]')?.setAttribute("disabled", "true");
      this.querySelector('.no-color')?.classList.remove('hidden');
      this.querySelector('.mp-selected-title')?.classList.remove("hidden");
      const fc = this.querySelector('.final-color');
      if (fc) { fc.textContent = ''; fc.classList.add('hidden'); }
      if (step3Btn) { step3Btn.disabled = true; step3Btn.setAttribute("disabled", ""); } // 🔒 start disabled
      const stepFinalBtn = this.querySelector('.continue-btn[data-step-final]');
      if (stepFinalBtn) { stepFinalBtn.disabled = true; stepFinalBtn.setAttribute('disabled', ''); }
      this.updateStickyBar();
    } else {
      this.setFinalSelectedColorPreviewVisibility(false);
      // this.querySelector('.continue-btn[data-step="3"]')?.removeAttribute("disabled");
      this.querySelector('.no-color')?.classList.add('hidden');
      this.querySelector('.mp-selected-title')?.classList.add("hidden");
      this.querySelector('.final-color')?.classList.remove("hidden");
      if (step3Btn) step3Btn.removeAttribute("disabled");
    }

    availableColors.forEach((btn) => {
      // Avoid double-binding handlers on the same element
      if (btn.dataset.mpBound) return;
      btn.dataset.mpBound = "1";
      if (step3Btn) step3Btn.setAttribute("disabled", "true"); // 🔒 start disabled
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        // Deactivate all siblings in the preview
        availableColors.forEach(c => {
          const lbl = c.querySelector('label');
          if (lbl) lbl.classList.remove('active');
          const img = c.querySelector('img');
          if (img) img.classList.remove('active');
        });
        const lbl = btn.querySelector('label');
        if (lbl) lbl.classList.add('active');
        const img = btn.querySelector('img');
        if (img) img.classList.add('active');

        // Activate clicked
        btn.classList.add("active");
        if (step3Btn) step3Btn.removeAttribute("disabled");
        const color = btn.getAttribute("data-color");

        const selectedTitle = this.querySelector('.final-color');
        if (selectedTitle) {
          selectedTitle.textContent = color ? color : '';
        }
        const variantImageRaw = btn.getAttribute("data-variant-image");

        const variantImage = variantImageRaw
          ? variantImageRaw
            .replace(/^url\((.*?)\)$/, "$1")
            .replace(/^\/\//, "https://")
          : null;


        // persist chosen color so "final" button can enable
        this.data.stepOne.color = color;
        this.data.stepTwo.color = color;
        this.setFinalSelectedColorPreviewVisibility(true);

        // Set preview image in final preview container if present
        const finalPreview = this.querySelector(
          "#final-selected-color-preview"
        );

        // Determine source lists based on which tab was used for each step (fallback to active tab)
        const stepOneTab =
          this.data.stepOne.style.tabBtn ||
          this.querySelector('.tab-button[data-step="1"].active')?.getAttribute(
            "data-target"
          ) ||
          "";
        const stepTwoTab =
          this.data.stepTwo.style.tabBtn ||
          this.querySelector('.tab-button[data-step="2"].active')?.getAttribute(
            "data-target"
          ) ||
          "";

        const sourceOne = stepOneTab.includes("women")
          ? Array.from(this.querySelectorAll(".all-color-women"))
          : Array.from(this.querySelectorAll(".all-color-men"));
        const sourceTwo = stepTwoTab.includes("women")
          ? Array.from(this.querySelectorAll(".all-color-women"))
          : Array.from(this.querySelectorAll(".all-color-men"));

        // Find matching variant / product for step one and step two using the selected color
        let stepOneProduct = null;
        if (
          this.data.stepOne &&
          this.data.stepOne.style &&
          this.data.stepOne.size
        ) {
          sourceOne.forEach((sbtn) => {
            if (
              sbtn.getAttribute("data-style") ===
              this.data.stepOne.style.name &&
              sbtn.getAttribute("data-size") === this.data.stepOne.size &&
              sbtn.getAttribute("data-color") === color
            ) {
              stepOneProduct = {
                name: sbtn.getAttribute("data-style"),
                color: sbtn.getAttribute("data-color"),
                variantId: sbtn.getAttribute("data-variantid") || null,
                price: sbtn.getAttribute("data-price") || null,
                variantImage:
                  (sbtn.getAttribute("data-variant-image") || "")
                    .replace(/^url\((.*?)\)$/, "$1")
                    .replace(/^\/\//, "https://") || null,
                productImage:
                  sbtn.getAttribute("data-image1") ||
                  sbtn.getAttribute("data-image") ||
                  null,
                productImageSecondary: sbtn.getAttribute("data-image2") || null,
                variantFeaturedImage:
                  this.normalizeImageUrl(
                    sbtn.getAttribute("data-image1") ||
                    sbtn.getAttribute("data-image")
                  ) || null,
                variantFeaturedImageSecondary:
                  this.normalizeImageUrl(sbtn.getAttribute("data-image2")) || null,
              };
            }
          });
        }

        let stepTwoProduct = null;
        if (
          this.data.stepTwo &&
          this.data.stepTwo.style &&
          this.data.stepTwo.size
        ) {
          sourceTwo.forEach((sbtn) => {
            if (
              sbtn.getAttribute("data-style") ===
              this.data.stepTwo.style.name &&
              sbtn.getAttribute("data-size") === this.data.stepTwo.size &&
              sbtn.getAttribute("data-color") === color
            ) {
              stepTwoProduct = {
                name: sbtn.getAttribute("data-style"),
                color: sbtn.getAttribute("data-color"),
                variantId: sbtn.getAttribute("data-variantid") || null,
                price: sbtn.getAttribute("data-price") || null,
                variantImage:
                  (sbtn.getAttribute("data-variant-image") || "")
                    .replace(/^url\((.*?)\)$/, "$1")
                    .replace(/^\/\//, "https://") || null,
                productImage:
                  sbtn.getAttribute("data-image2") ||
                  sbtn.getAttribute("data-image1") ||
                  sbtn.getAttribute("data-image") ||
                  null,
                productImageSecondary:
                  sbtn.getAttribute("data-image1") ||
                  sbtn.getAttribute("data-image") ||
                  null,
                variantFeaturedImage:
                  this.normalizeImageUrl(
                    sbtn.getAttribute("data-image2") ||
                    sbtn.getAttribute("data-image1") ||
                    sbtn.getAttribute("data-image")
                  ) || null,
                variantFeaturedImageSecondary:
                  this.normalizeImageUrl(
                    sbtn.getAttribute("data-image1") ||
                    sbtn.getAttribute("data-image")
                  ) || null,
              };
            }
          });
        }

        // Keep your existing structure for stepThree; ensure it's reset and then pushed
        if (!this.data.stepThree) this.data.stepThree = [];
        this.data.stepThree = []; // replace with the newest selection
        this.data.stepThree.push({
          stepOneProduct: stepOneProduct || {
            name: this.data.stepOne?.style?.name || null,
            color,
            variantId: null,
            variantImage: null,
            productImage: null,
            productImageSecondary: null,
            variantFeaturedImage: null,
            variantFeaturedImageSecondary: null,
          },
          stepTwoProduct: stepTwoProduct || {
            name: this.data.stepTwo?.style?.name || null,
            color,
            variantId: null,
            variantImage: null,
            productImage: null,
            productImageSecondary: null,
            variantFeaturedImage: null,
            variantFeaturedImageSecondary: null,
          },
        });
        const mainParent = btn.closest(".step-content");
        // Enable final continue button if appropriate
        this.enableContinueButton("final", mainParent);
        this.hasSelectedColor = true;  // color chosen at least once
        this.syncUI();

      });
    });
  }

  filterColors() {
    const stepOneStyle = this.data.stepOne?.style?.name;
    const stepOneSize = this.data.stepOne?.size;
    const stepTwoStyle = this.data.stepTwo?.style?.name;
    const stepTwoSize = this.data.stepTwo?.size;

    const previewContainer = this.querySelector("#matching-colors-preview");
    if (!previewContainer) return;

    // Clear previous options early
    previewContainer.innerHTML = "";
    // Clear any previously displayed color name to avoid stale labels
    const finalColorLabel = this.querySelector('.final-color');
    if (finalColorLabel) finalColorLabel.textContent = '';

    // Utility: reset Step 3 CTAs and labels when colors are unavailable
    const disableColorStep = (showNoColorMsg = false) => {
      // Disable the Step 3 continue/review button(s)
      const step3Btn = this.querySelector('.continue-btn[data-step="3"]');
      const stepFinalBtn = this.querySelector('.continue-btn[data-step-final]');
      if (step3Btn) { step3Btn.disabled = true; step3Btn.setAttribute('disabled', ''); }
      if (stepFinalBtn) { stepFinalBtn.disabled = true; stepFinalBtn.setAttribute('disabled', ''); }

      // Clear any previously shown color text and hide the color label
      const finalColorEl = this.querySelector('.final-color');
      if (finalColorEl) {
        finalColorEl.textContent = '';
        finalColorEl.classList.add('hidden');
      }

      // Show/Hide helper messages
      const noColorEl = this.querySelector('.no-color');
      const selectedTitleEl = this.querySelector('.mp-selected-title');
      if (noColorEl) noColorEl.classList.toggle('hidden', !showNoColorMsg);
      if (selectedTitleEl) selectedTitleEl.classList.remove('hidden');

      // Clear color state so the final step can’t proceed
      this.data.stepOne.color = null;
      this.data.stepTwo.color = null;
      this.hasSelectedColor = false;
      this.data.stepThree = [];
      this.setFinalSelectedColorPreviewVisibility(false);

      // Keep sticky CTA in sync
      this.updateStickyBar();
    };

    // must have style + size for both steps to compute intersection
    if (!stepOneStyle || !stepOneSize || !stepTwoStyle || !stepTwoSize) {
      // prerequisites not met → ensure CTAs are disabled and labels cleared
      disableColorStep(false);
      return;
    }

    // Resolve which set (.all-color-men or .all-color-women) to use for each step (use tabBtn if saved, otherwise fallback to active tab)
    const stepOneTab =
      this.data.stepOne.style.tabBtn ||
      this.querySelector('.tab-button[data-step="1"].active')?.getAttribute(
        "data-target"
      ) ||
      "";
    const stepTwoTab =
      this.data.stepTwo.style.tabBtn ||
      this.querySelector('.tab-button[data-step="2"].active')?.getAttribute(
        "data-target"
      ) ||
      "";

    const sourceOne = stepOneTab.includes("women")
      ? Array.from(this.querySelectorAll(".all-color-women"))
      : Array.from(this.querySelectorAll(".all-color-men"));
    const sourceTwo = stepTwoTab.includes("women")
      ? Array.from(this.querySelectorAll(".all-color-women"))
      : Array.from(this.querySelectorAll(".all-color-men"));

    // Collect available colors for each step
    const colorsStepOne = new Set();
    sourceOne.forEach((btn) => {
      if (
        btn.getAttribute("data-style") === stepOneStyle &&
        btn.getAttribute("data-size") === stepOneSize
      ) {
        colorsStepOne.add(btn.getAttribute("data-color"));
      }
    });

    const colorsStepTwo = new Set();
    sourceTwo.forEach((btn) => {
      if (
        btn.getAttribute("data-style") === stepTwoStyle &&
        btn.getAttribute("data-size") === stepTwoSize
      ) {
        colorsStepTwo.add(btn.getAttribute("data-color"));
      }
    });

    // Intersection of colors
    const commonColors = new Set(
      [...colorsStepOne].filter((c) => colorsStepTwo.has(c))
    );

    if (commonColors.size === 0) {
      // nothing common — leave preview empty but also disable CTAs and show message
      disableColorStep(true);
      return;
    }

    // Render unique common colors (choose representative button from sourceOne or sourceTwo)
    const uniqueColors = new Set();
    let firstVisibleColor = null;

    const mergedSources = [...sourceOne, ...sourceTwo];
    const frag = document.createDocumentFragment();
    for (const origBtn of mergedSources) {
      const color = origBtn.getAttribute("data-color");
      if (!color) continue;
      if (!commonColors.has(color)) continue;
      if (uniqueColors.has(color)) continue;

      const clonedBtn = origBtn.cloneNode(true);
      // ensure cloned btn is not marked bound yet (so initColorSelectors will bind)
      delete clonedBtn.dataset.mpBound;

      // normalize and set a usable image if present
      const variantImageRaw = clonedBtn.getAttribute("data-variant-image");
      if (variantImageRaw.startsWith("url(")) {
        const variantImage = variantImageRaw
          .replace(/^url\((.*?)\)$/, "$1")
          .replace(/^\/\//, "https://");

        // ✅ Only add <img> if it's http(s), not rgb(...) or a plain color
        if (variantImage.startsWith("http")) {
          let img = clonedBtn.querySelector("img");
          if (img) img.src = variantImage;
          else {
            img = document.createElement("img");
            img.classList.add("color-swatch-image");
            img.src = variantImage;
            clonedBtn.appendChild(img);
          }
        }
      }

      if (variantImageRaw.startsWith("rgb(")) {
        clonedBtn.querySelector('.swatch').style.backgroundColor = variantImageRaw;
      }

      const colorTag = (clonedBtn.getAttribute("data-color-tag") || "").trim();
      if (colorTag && !clonedBtn.querySelector('.color-tag')) {
        const tagEl = document.createElement('span');
        tagEl.className = 'color-tag';
        tagEl.textContent = colorTag;
        clonedBtn.appendChild(tagEl);
      }

      frag.appendChild(clonedBtn);
      uniqueColors.add(color);
      if (!firstVisibleColor) firstVisibleColor = clonedBtn;
    }

    // Append all at once to reduce reflow
    previewContainer.appendChild(frag);

    // After cloning, bind click handlers on newly added buttons
    this.initColorSelectors();
  }

  // --- Edit handlers ---
  initEditHandlers() {
    this.addEventListener("click", (e) => {
      const btn = e.target.closest(".swatch-row-edit");
      if (!btn) return;

      // Are we editing YOU (step 1) or YOUR PARTNER (step 2)?
      const boxMen = btn.closest(".mp-product-image-men");
      const boxWomen = btn.closest(".mp-product-image-women");
      if (!boxMen && !boxWomen) return;

      const step = boxMen ? 1 : 2;

      // 1) Hide summary
      const summary = this.querySelector("#summary")?.parentElement;
      if (summary) summary.classList.add("hidden");

      // 2) Show only the chosen step’s outer container
      const stepContent = this.querySelector(
        `.step[data-step="${step}"] .step-content`
      );
      if (stepContent) stepContent.classList.remove("hidden");

      // 3) Show the exact mp-content/tab the user used earlier
      const savedTarget =
        step === 1
          ? this.data.stepOne?.style?.tabBtn || `men-content-1`
          : this.data.stepTwo?.style?.tabBtn || `men-content-2`;

      this.querySelectorAll(`.mp-content[data-step="${step}"]`).forEach((c) =>
        c.classList.add("hidden")
      );
      const mpToShow = this.querySelector(
        `.mp-content[data-step="${step}"][data-target="${savedTarget}"]`
      );
      if (mpToShow) mpToShow.classList.remove("hidden");

      // Sync tab active state in this step
      const tabGroup = stepContent.querySelector(".tabs");
      if (tabGroup) {
        tabGroup
          .querySelectorAll(".tab-button")
          .forEach((b) => b.classList.remove("active"));
        const matchBtn = tabGroup.querySelector(
          `.tab-button[data-target="${savedTarget}"]`
        );
        if (matchBtn) matchBtn.classList.add("active");
      }

      // 4) Mark this step as being edited (so Continue → Step 4)
      this.setEditMode(step, true);
      this.editingStep = step
      this.currentStep = step;
      this.mediaForceVisible = true;   // once editing, always show selected images
      this.syncUI();
    });
  }

  // Toggle "UPDATE" label on a step's Continue button
  setEditMode(step, on) {
    const stepScope = this.querySelector(`.step[data-step="${step}"]`);
    if (!stepScope) return;

    // Helper to (re)label all continue buttons in this step
    const applyLabel = (obs) => {
      stepScope.querySelectorAll('.continue-btn').forEach((btn) => {
        if (on) {
          if (!btn.dataset.originalText) btn.dataset.originalText = (btn.textContent || '').trim();
          const desired = 'UPDATE';
          if ((btn.textContent || '').trim() !== desired) {
            if (obs) obs.disconnect();
            btn.textContent = desired;           // only write if different
            btn.dataset.editing = '1';
            if (obs) obs.observe(stepScope, { childList: true, subtree: true });
          }
        } else {
          const original = btn.dataset.originalText || '';
          if ((btn.textContent || '').trim() !== original) {
            if (obs) obs.disconnect();
            btn.textContent = original;
            if (obs) obs.observe(stepScope, { childList: true, subtree: true });
          }
          btn.removeAttribute('data-editing');
          delete btn.dataset.originalText;
        }
      });
    };

    applyLabel();

    // Delegate once so any continue button in this step is intercepted
    if (on) this.ensureEditDelegation();

    // Observe DOM changes within the step (tab switches, re-renders) and keep labels correct
    if (on && !stepScope._mpObserver) {
      const obs = new MutationObserver(() => {
        if (this.editingStep === step) applyLabel(obs);
      });
      obs.observe(stepScope, { childList: true, subtree: true });
      stepScope._mpObserver = obs;
    } else if (!on && stepScope._mpObserver) {
      stepScope._mpObserver.disconnect();
      delete stepScope._mpObserver;
    }
  }

  ensureEditDelegation() {
    if (this._editDelegated) return;
    this._editDelegated = true;

    // Capture-phase so we beat other handlers
    this.addEventListener('click', (ev) => {
      if (!this.editingStep) return;

      // Any continue button within the step being edited
      const btn = ev.target.closest(`.step[data-step="${this.editingStep}"] .continue-btn`);
      if (!btn) return;

      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

      // Jump to Step 3 (since that's your current requirement)
      this.jumpToStep3AfterEdit(this.editingStep);
    }, true);
  }

  jumpToStep3AfterEdit(fromStep) {
    // Hide edited step panels

    const selectedTitle = this.querySelector('.final-color');
    if (selectedTitle) {
      selectedTitle.textContent = '';
    }

    const fromContent = this.querySelector(`.step[data-step="${fromStep}"] .step-content`);
    if (fromContent) fromContent.classList.add('hidden');
    this.querySelectorAll(`.mp-content[data-step="${fromStep}"]`).forEach(c => c.classList.add('hidden'));

    // Hide summary if visible
    const summary = this.querySelector('#summary')?.parentElement;
    if (summary) summary.classList.add('hidden');

    // Show Step 3 (Color)
    const step3 = this.querySelector(`.step[data-step="3"] .step-content`);
    if (step3) step3.classList.remove('hidden');

    // Leave edit mode
    this.setEditMode(fromStep, false);
    this.editingStep = null;

    // Move state and (optionally) update any UI indicators
    this.currentStep = 3;
    // this.updateStepHeader?.(3);

    // Keep UI and sticky CTA in sync after jumping
    this.syncUI();

    // If Step 3 has multiple panes, ensure the right one is visible here as needed
  }

  // --- Navigation and step display logic ---
  navigateSteps() {
    const continueButtons = this.querySelectorAll(".continue-btn");

    continueButtons.forEach((btn) => {
      // Prevent duplicate bindings if this is called again
      if (btn.dataset.mpNavBound === "1") return;
      btn.dataset.mpNavBound = "1";

      btn.addEventListener("click", (ev) => {
        const stepAttr = btn.getAttribute("data-step");
        const isFinal = btn.hasAttribute("data-step-final");
        if (!stepAttr && !isFinal) return;
        const step = stepAttr ? parseInt(stepAttr, 10) : null;

        if (step && this.editingStep === step) {
          ev.preventDefault();
          ev.stopPropagation();
          // hide the step we’re editing
          const currentStepContent = this.querySelector(`.step[data-step="${step}"] .step-content`);
          if (currentStepContent) currentStepContent.classList.add("hidden");
          this.querySelectorAll(`.mp-content[data-step="${step}"]`).forEach(c => c.classList.add("hidden"));

          // show summary (step 4)
          const summary = this.querySelector("#summary")?.parentElement;
          if (summary) summary.classList.remove("hidden");

          // clear edit mode visuals  state
          this.setEditMode(step, false);
          this.editingStep = null;

          // go to step 4 and refresh the review
          this.currentStep = 4;
          this.updateReview();
          return; // stop the normal "next step" flow
        }


        // If this step's button is in EDIT mode, jump straight to Step 4
        if (step && btn.dataset.editing === "1") {
          // 1) Hide the step we’re on (same as your existing logic)
          const currentStepContent = this.querySelector(
            `.step[data-step="${step}"] .step-content`
          );
          if (currentStepContent) currentStepContent.classList.add("hidden");
          this.querySelectorAll(`.mp-content[data-step="${step}"]`).forEach(
            (c) => c.classList.add("hidden")
          );

          // 2) Show summary
          const summary = this.querySelector("#summary")?.parentElement;
          if (summary) summary.classList.remove("hidden");

          // 3) Restore button text and leave edit mode
          this.setEditMode(step, false);

          // 4) Go to step 4 and refresh the review
          this.currentStep = 4;
          this.updateReview();
          this.syncUI();
          return; // <-- prevent normal "go to next step" behavior
        }

        // --- 1. Hide current step fully (outer  inner mp-content) ---
        if (step) {
          const currentStepContent = this.querySelector(
            `.step[data-step="${step}"] .step-content`
          );
          if (currentStepContent) currentStepContent.classList.add("hidden");

          const currentMpContents = this.querySelectorAll(
            `.mp-content[data-step="${step}"]`
          );
          currentMpContents.forEach((c) => c.classList.add("hidden"));
        }

        // --- 2. Decide next step ---
        if (isFinal) {
          this.currentStep = 4;
        } else {
          this.currentStep = step + 1;
        }

        // --- 3. Show the next step ---
        if (this.currentStep === 2) {
          // show active tab of step 2
          const activeTab = this.querySelector(
            `.tab-button[data-step="2"].active`
          );
          const target = activeTab
            ? activeTab.getAttribute("data-target")
            : "men-content-2";

          const nextStepContent = this.querySelector(
            `.step[data-step="2"] .step-content`
          );
          if (nextStepContent) nextStepContent.classList.remove("hidden");

          const nextMpContent = this.querySelector(
            `.mp-content[data-step="2"][data-target="${target}"]`
          );
          if (nextMpContent) nextMpContent.classList.remove("hidden");
          this.syncUI();
        } else if (this.currentStep === 3) {
          const step3 = this.querySelector(`#step-3`)?.parentElement;
          if (step3) step3.classList.remove("hidden");
          this.syncUI();
        } else if (this.currentStep === 4) {
          const summary = this.querySelector(`#summary`)?.parentElement;
          if (summary) summary.classList.remove("hidden");
          this.updateReview();
          this.syncUI();
        }
      });
    });
  }

  initStepTitles() {
    const stepTitles = this.querySelectorAll(".step-title");

    stepTitles.forEach((title) => {
      title.addEventListener("click", (e) => {
        const step = parseInt(title.getAttribute("data-step-title"), 10);

        // 🔒 Block step 4 until first 3 are done
        if (
          step === 4 &&
          (!this.data.stepOne.style.name || !this.data.stepOne.size ||
            !this.data.stepTwo.style.name || !this.data.stepTwo.size ||
            !this.data.stepOne.color || !this.data.stepTwo.color)
        ) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        // existing logic continues...
        const allContents = this.querySelectorAll(".step .step-content, .mp-content");
        allContents.forEach((c) => c.classList.add("hidden"));

        const targetContent = this.querySelector(`.step[data-step="${step}"] .step-content`);
        if (targetContent) {
          targetContent.classList.remove("hidden");
          const activeTab = this.querySelector(`.tab-button[data-step="${step}"].active`);
          if (activeTab) {
            const target = activeTab.getAttribute("data-target");
            const mpContent = this.querySelector(`.mp-content[data-step="${step}"][data-target="${target}"]`);
            if (mpContent) mpContent.classList.remove("hidden");
          }
        }
        this.currentStep = step;
        if (this.currentStep === 4) this.updateReview();
      });
    });
  }

  enableContinueButton(step, parent) {

    const visibleScope =
      this.querySelector(`.mp-content[data-step="${step}"]:not(.hidden)`) ||
      this.querySelector(`.step[data-step="${step}"]`);
    const allBtns = Array.from(this.querySelectorAll(
      `.step[data-step="${step}"] .continue-btn[data-step="${step}"]`
    ));
    const btn = visibleScope?.querySelector(`.continue-btn[data-step="${step}"]`) || allBtns[0];
    if (!btn) { this.updateStickyBar(); return; }

    let disabled;

    if (step === "1") {
      // Check which tab is active
      const activeTab = this.querySelector(`.tab-button[data-step="1"].active`);
      const tabTarget = activeTab
        ? activeTab.getAttribute("data-target")
        : "men-content-1";

      // Enable only if style + size exist for stepOne
      disabled = !(this.data.stepOne.style.name && this.data.stepOne.size);
    }

    if (step === "2") {
      const activeTab = this.querySelector(`.tab-button[data-step="2"].active`);
      const tabTarget = activeTab
        ? activeTab.getAttribute("data-target")
        : "men-content-2";

      disabled = !(this.data.stepTwo.style.name && this.data.stepTwo.size);

    }

    if (step === "final") {
      disabled = !(this.data.stepOne.color && this.data.stepTwo.color);
    }
    allBtns.forEach(b => {
      b.disabled = disabled;
      if (disabled) b.setAttribute('disabled', ''); else b.removeAttribute('disabled');
    });
    this.updateStickyBar();
  }

  updateReview() {
    const menSize = document.getElementById("men-size");
    const menStyle = document.getElementById("men-style");
    const womenSize = document.getElementById("women-size");
    const womenStyle = document.getElementById("women-style");

    function capitalize(str) {
      if (!str) return "N/A";
      return String(str)
        .toLowerCase()
        .split(/\s+/) // split on spaces (handles multiple spaces too)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }

    // Preserve size casing (e.g., XXL stays XXL)
    function formatSize(size) {
      if (!size) return "N/A";
      return String(size).toUpperCase();
    }

    if (menSize && menStyle && womenSize && womenStyle) {
      menSize.textContent = formatSize(this.data.stepOne.size) || "N/A";
      menStyle.textContent = capitalize(this.data.stepOne.style.name) || "N/A";
      womenSize.textContent = formatSize(this.data.stepTwo.size) || "N/A";
      womenStyle.textContent = capitalize(this.data.stepTwo.style.name) || "N/A";
    }

    const menImg = this.querySelector(
      ".mp-product-image-men img[js-product-img]"
    );
    const womenImg = this.querySelector(
      ".mp-product-image-women img[js-product-img]"
    );

    // prefer the picked color’s variant image, then fall back to swatch image, then base style image
    const stepThree = this.data.stepThree && this.data.stepThree[0];
    const menChosen =
      this.data.stepOne.style.image ||
      stepThree?.stepOneProduct?.variantFeaturedImage ||
      stepThree?.stepOneProduct?.variantFeaturedImageSecondary ||
      stepThree?.stepOneProduct?.variantImage;

    const womenChosen =
      this.data.stepTwo.style.image ||
      stepThree?.stepTwoProduct?.variantFeaturedImage ||
      stepThree?.stepTwoProduct?.variantFeaturedImageSecondary ||
      stepThree?.stepTwoProduct?.variantImage;

    if (menImg)
      menImg.src =
        menChosen ||
        "https://cdn.shopify.com/s/files/1/0231/1448/1744/files/Frame_1.png?v=1699247014";
    if (womenImg)
      womenImg.src =
        womenChosen ||
        "https://cdn.shopify.com/s/files/1/0231/1448/1744/files/Frame_1.png?v=1699247014";

    const colorBox = this.querySelector(".selected-color");
    if (colorBox) {
      const colorName =
        this.data.stepOne.color || this.data.stepTwo.color || "—";
      const swatchUrl =
        stepThree?.stepOneProduct?.variantImage ||
        stepThree?.stepTwoProduct?.variantImage ||
        ""; // may be a url(...) or rgb(...)

      // Build the card content
      colorBox.innerHTML = `
        <h3>Color</h3>
        <div class="mp-color-card">
          <div class="mp-color-swatch"></div>
          <p class="swatch-row-color"><strong id="selected-color-name">${capitalize(colorName)}</strong></p>
          <p class="swatch-row-edit">Edit</p>
        </div>
      `;

      // If swatchUrl is an image url(...) or http(s), use as background; if plain color (rgb/hex), it still works.
      const swatchEl = colorBox.querySelector(".mp-color-swatch");
      if (swatchEl) {
        // swatchUrl may be: "http(s)://....jpg", "url(https://...)", or "rgb(...)" / "#hex"
        const raw = (
          stepThree?.stepOneProduct?.variantImage ||
          stepThree?.stepTwoProduct?.variantImage ||
          ""
        ).trim();

        // Normalize possible "url(...)" wrapper
        const unwrapped = raw.replace(/^url\((.*?)\)$/i, "$1");

        // Decide: image URL or plain color?
        const isImage = /^https?:\/\//i.test(unwrapped);

        // Reset the container
        swatchEl.innerHTML = "";

        if (isImage) {
          // ✅ Show IMAGE swatch
          const img = document.createElement("img");
          img.src = unwrapped;                    // guaranteed http(s)
          img.alt = "Selected color swatch";
          img.style.width = "100%";
          img.style.height = "100%";
          img.style.borderRadius = "50%";
          img.style.objectFit = "cover";
          swatchEl.appendChild(img);
        } else if (raw) {
          // ✅ Show COLOR swatch (rgb(...) or #hex)
          swatchEl.style.background = raw;
          swatchEl.style.backgroundSize = "cover";
        } else {
          // No swatch data at all (optional neutral fallback)
          swatchEl.style.background = stepThree?.stepOneProduct.color || "#eee";
        }
      }

      // Make "Edit" jump back to Step 3
      const edit = colorBox.querySelector(".swatch-row-edit");
      if (edit && !edit.dataset.mpBound) {
        edit.dataset.mpBound = "1";
        edit.addEventListener("click", () => {
          // hide summary, show step 3
          const summary = this.querySelector("#summary")?.parentElement;
          if (summary) summary.classList.add("hidden");
          const step3 = this.querySelector(
            `.step[data-step="3"] .step-content`
          );
          if (step3) step3.classList.remove("hidden");
          this.currentStep = 3;
          this.navigateSteps();
        });
      }
    }
    this.updateMediaBox();   // keep media in sync when opening review
    this.updateStickyBar();
    this.refreshATCPrices();
  }

  async addToCart() {
    const st3 = this.data?.stepThree?.[0];
    if (!st3) return alert("Please complete all steps before adding to cart");

    const items = [];
    if (st3.stepOneProduct?.variantId) {
      items.push({ id: st3.stepOneProduct.variantId, quantity: 1 });
    }
    if (st3.stepTwoProduct?.variantId) {
      items.push({ id: st3.stepTwoProduct.variantId, quantity: 1 });
    }

    if (items.length === 0) {
      alert("No variants selected");
      return;
    }

    const sticky = this._stickyBtn
    if (sticky) {
      sticky.classList.add('secondary-atc', 'loading');
      sticky.disabled = true;
    }
    if (this.atcBtn) this.atcBtn.classList.add('secondary-atc', 'loading');

    try {
      const sectionIds = this._getCartSectionIds();

      const formData = new FormData();
      items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity ?? 1);
      });

      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
      }
      formData.append('sections_url', window.location.pathname);

      const fetchCfg = fetchConfig('javascript', { body: formData });
      const res = await fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
          ...fetchCfg.headers,
          Accept: 'text/html',
        },
      });

      const response = await res.json();
      if (!res.ok || response.status) {
        const message = response.message || response.description || 'Sorry, could not add to bag';
        throw new Error(message);
      }

      const sections = await this._buildSectionsPayload(sectionIds, response.sections);

      const cartRes = await fetch("/cart.js", { cache: 'no-store' });
      const cartData = await cartRes.json();
      const itemCount = cartData.item_count;

      this._emitCartUpdate({
        sectionIds,
        sections,
        productId: items[0]?.id,
        itemCount,
      });
    } catch (err) {
      console.error('ATC failed', err);
      alert(err?.message || "Sorry, could not add to bag");
    } finally {
      if (this.atcBtn) this.atcBtn.classList.remove('secondary-atc', 'loading');
      if (sticky) {
        sticky.classList.remove('secondary-atc', 'loading');
        sticky.removeAttribute("disabled");
      }
    }
  }

  _getCartSectionIds() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
      const sectionId = component?.dataset?.sectionId;
      if (sectionId) ids.add(sectionId);
    });
    return Array.from(ids);
  }

  async _buildSectionsPayload(sectionIds, sections = {}) {
    const payload = sections ? { ...sections } : {};
    const missing = sectionIds.filter((id) => id && !payload[id]);

    if (!missing.length) return payload;

    await Promise.all(
      missing.map(async (sectionId) => {
        try {
          payload[sectionId] = await sectionRenderer.getSectionHTML(sectionId, false);
        } catch (error) {
          console.warn(`Failed to render section ${sectionId}`, error);
        }
      })
    );

    return payload;
  }

  _emitCartUpdate({ sectionIds, sections, productId, itemCount }) {
    const primarySectionId = sectionIds[0] || '';
    this.dispatchEvent(
      new CartAddEvent({}, primarySectionId, {
        didError: false,
        source: 'matching-pair-component',
        itemCount,
        productId,
        sections,
      })
    );

    this._openCartDrawer();
  }

  _openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer?.hasAttribute('auto-open')) {
      cartDrawer.open?.();
    }
  }

}

customElements.define("matching-pair", MatchingPair);

// reset matching pair bundle
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector("#create-your-pair-btn");
  const modal = document.querySelector("#matching-pair-modal");
  const closeBtn = document?.querySelector(".modal-close");

  if (openBtn && modal && closeBtn) {
    openBtn.addEventListener("click", () => {
      modal.classList.remove("hidden");
      document.body.classList.add("matching-pair-popup");
    });

    closeBtn.addEventListener("click", () => {
      const mp = modal.querySelector('matching-pair');
      mp?.resetAll?.(); // 🔄 reset everything to a fresh state
      modal.classList.add("hidden");
      document.body.classList.remove("matching-pair-popup");
    });
  }
});
